import type { Components, Theme } from '@mui/material/styles';

export const height = 8;

const MuiAppBar: Components['MuiAppBar'] = {
  styleOverrides: {
    root: ({ theme: { spacing, palette } }: { theme: Theme }) => ({
      backgroundColor: palette.background.default,
      height: spacing(height)
    })
  }
} as never;

export default MuiAppBar;
